// eslint-disable-next-line no-restricted-globals
var defined = function defined(d) {
  return typeof d !== 'undefined' && d !== null && !isNaN(d);
};

export default defined;